import _ from 'underscore';
import GenericModel from 'js/models/generic.model';
import i18n from 'l10n';
import XRegExp from 'xregexp';

require('unorm');
require('metroHelpers');

class SubscriberModel extends GenericModel {
    urlRoot = '/CampaignCloud/Subscription';
    idAttribute = 'subscriptionId';

    constructor(options) {
        super(_.extend({rx: XRegExp('\\p{L}')}, options));
    }

    myInitial() {
        var ln = this.get("subscriber").lastName;
        var fn = this.get("subscriber").firstName;
        var f;
        if (ln) {
            f = ln.charAt(0);
            if (!this.get("rx").test(f)) {
                // it is not a letter
                return "_";
            }
            return ln.normalize("NFD").charAt(0).toLowerCase();
        } else if (fn) {
            f = fn.charAt(0);
            if (!this.get("rx").test(f)) {
                // it is not a letter
                return "_";
            }
            return fn.normalize("NFD").charAt(0).toLowerCase();
        } else {
            return "_";
        }
    }

    myName() {
        if (!this.get("subscriber").lastName && !this.get("subscriber").firstName) {
            if (this.get("msisdn")) {
                return this.get("msisdn");
            } else if (this.get("subscriber").email) {
                return this.get("subscriber").email;
            }
            return this.get("subscriptionId");
        }
        return (this.get("subscriber").lastName || "") + " " + (this.get("subscriber").firstName || "");
    }

    myText() {
        var s = _.reduce(
            [
                this.get("subscriber").firstName,
                this.get("subscriber").lastName,
                this.get("msisdn"),
                this.get("subscriber").email
            ],
            function (memo, v) {
                return v ? memo + ' ' + v : memo;
            },
            '');
        return s.toLowerCase();
    }

    async addContactToGroup(gid) {
        try {
            const data = await $.ajaxDefaultQ({
                url: `/CampaignCloud/Group/${gid}/items/${this.get(this.idAttribute)}`,
                type: 'PUT',
                dataType: 'json'
            });
            if (data.outcome === "OK") {
                await this.fetch();
                if (gid === 1) {
                    this.trigger('toggleBlock', this);
                } else {
                    this.trigger('toggleBounced', this);
                }
                this.trigger("blockedChanged");
            } else {
                $.Notify.error(i18n.t("groups.contactingroup") + '.');
            }
        } catch (e) {
            $.Notify.error(`${i18n.t("groups.putfailed")} = ${e.status ? e.status : ""}`);
        }
    }

    async removeContactFromGroup(gid) {
        try {
            const data = await $.ajaxDefaultQ({
                url: `${this.url()}/Groups/${gid}/remove`,
                type: 'DELETE',
                dataType: 'json'
            });
            if (data.outcome === "OK") {
                await this.fetch();
                if (gid === 1) {
                    this.trigger('toggleBlock', this);
                } else {
                    this.trigger('toggleBounced', this);
                }
                this.trigger("blockedChanged");
            } else {
                $.Notify.error(i18n.t("groups.contactnotingroup") + '.');
            }

        } catch (e) {
            $.Notify.error(`${i18n.t("groups.putfailed")} = ${e.status ? e.status : ""}`);
        }
    }

    blockContact(gid) {
        this.addContactToGroup(gid);
    }

    unblockContact(gid) {
        this.removeContactFromGroup(gid);
    }
}

export default SubscriberModel;
